import React, { useRef, useState } from 'react';
import AccurityIconButton from '../../../buttons/components/AccurityIconButton';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import { Checkbox, ListItemText } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
var LinkToggle = function (_a) {
    var allOptions = _a.allOptions, selectedOptions = _a.selectedOptions, onToggle = _a.onToggle;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var anchorEl = useRef(null);
    return (React.createElement("div", { className: "linkToggle" },
        React.createElement(AccurityIconButton, { iconName: "mui:FilterList", size: "small", title: "Toggle relationships", "aria-label": "diagram__toggleRelationships", onClick: function () { return setOpen(true); }, ref: anchorEl }),
        React.createElement(Popover, { open: open, onClose: function () { return setOpen(false); }, anchorEl: !!anchorEl ? anchorEl.current : null, anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            } },
            React.createElement(List, { className: "linkToggle__list" }, allOptions.sort().map(function (option) {
                return React.createElement(ListItem, { key: "linkToggle-" + option, onClick: function () { return onToggle(option); }, button: true },
                    React.createElement(ListItemIcon, null,
                        React.createElement(Checkbox, { checked: selectedOptions.includes(option), color: "primary", edge: "end", tabIndex: -1, disableRipple: true })),
                    React.createElement(ListItemText, { className: 'linkToggle__listLabel' },
                        React.createElement(Typography, { noWrap: true }, option)));
            })))));
};
export default LinkToggle;
//# sourceMappingURL=LinkToggle.js.map